export const ApplePayUtils = {
  APPLE_PAY: 'AP',
  isEnabled: () =>
    (window.ApplePaySession && window.ApplePaySession.canMakePayments()) ===
    true,
};
